import { Component, computed, input } from '@angular/core';
import { ProjectPublicResponse } from '@app/models/project.models';
import { FileResponse } from '@app/models/shared.models';
import { FileType } from '@app/models/shared.enums';
import { DownloadableFileListComponent } from '@app/components/downloadable-file-list/downloadable-file-list.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-project-details-downloads',
  standalone: true,
  imports: [TranslatePipe, DownloadableFileListComponent],
  templateUrl: './project-details-downloads.component.html',
  styleUrl: './project-details-downloads.component.scss',
})
export class ProjectDetailsDownloadsComponent {
  readonly projectDetails = input.required<ProjectPublicResponse>();

  readonly documents = computed<FileResponse[]>(() => {
    const project = this.projectDetails();
    const files = project.files ?? [];
    return files.filter((file) => {
      const isImage =
        file.fileType === FileType.image ||
        file.fileType === FileType.mainImage ||
        file.contentType?.toLowerCase().includes('image');
      const isVideo =
        file.fileType === FileType.video ||
        file.contentType?.toLowerCase().includes('video');
      return !isImage && !isVideo;
    });
  });
}
